<vip-manutencao
  class="vip-page-content"
  [mensagem]="(filial$ | async)?.mensagem_manutencao || ''"
  [error]="error"
>
</vip-manutencao>
